import { useTooltip } from "context/TooltipProvider";
import React, { useEffect, useState } from "react";
import { fetchPettyOffenceDecisionType } from "services/basedataServices";
import { editReceivingInvestigationFile2 } from "services/prosecutorPoliceService";
import { InvestigationFile, PettyOffenceDecisionTypeList } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandlerOnForm } from "utils/helper";
import FileUpload from "./FileUpload";

interface Props {
  file: InvestigationFile;
  setRefetch: () => void;
  onCancel: () => void;
}

const PettyOffeneRequest: React.FC<Props> = ({
  file,
  onCancel,
  setRefetch,
}) => {
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = React.useState(false);

  const [formState, setFormState] = useState({
    is_peety_offence: false,
    petty_offence_decison: "",
    petty_offence_decision_reason: "",
    petty_offence_decision_date: new Date(),
  });

  const [baseData, setBaseData] = useState<{
    decisionType: PettyOffenceDecisionTypeList[];
  }>({
    decisionType: [],
  });

  useEffect(() => {
    fetchPettyOffenceDecisionType().then((data) =>
      setBaseData((prev) => ({
        ...prev,
        decisionType: data as unknown as PettyOffenceDecisionTypeList[],
      }))
    );
  }, []);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formState.petty_offence_decison)
      return "Petty Offence Decision is required.";
    if (!formState.petty_offence_decision_reason)
      return "Petty Offence Decision Reason is required.";
    if (!formState.petty_offence_decision_date)
      return "Petty Offence Decision Date is required.";
    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    setLoading(true);
    const formData = {
      id: file?.id,
      prosecutor_decision_type: "petty_offence",
      prosecutor_decision_status: "pending",
      ...formState,
    };
    editReceivingInvestigationFile2(formData)
      .then(() => {
        showTooltip("Successfully Submitted!", "success");
        setRefetch();
        onCancel();
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onCancel();
    }
  };

  const handleFile = (name: string, file: File | null) => {
    setFormState({ ...formState, [name]: file });
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">
          Petty Offence Request
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="rounded-lg mt-4">
            <div className="flex flex-row gap-4 place-items-end">
              {/* <div className="flex flex-1 flex-col mt-4">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Petty Offence Decision
                </label>
                <input
                  type="text"
                  className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                  name="petty_offence_decison"
                  value={formState?.petty_offence_decison ?? ""}
                  onChange={handleChange}
                />
              </div> */}

              <div className="flex flex-col mt-4 w-full">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Decision
                </label>
                <select
                  className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                  name="petty_offence_decison"
                  value={formState?.petty_offence_decison ?? ""}
                  onChange={handleChange}
                >
                  <option value={""}>Select Decision</option>
                  {baseData?.decisionType.map((type, index) => (
                    <option key={index} value={type?.name}>
                      {type?.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className="flex flex-row gap-2">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Is Petty Offence?
                </label>
                <input
                  type="checkbox"
                  name="is_peety_offence"
                  checked={!!formState.is_peety_offence}
                  onChange={(e) =>
                    setFormState((prev) => ({
                      ...prev,
                      is_peety_offence: e.target.checked,
                    }))
                  }
                  className="w-5 h-5"
                />
              </div> */}
            </div>

            <div className="flex flex-col mt-4">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Petty Offence Decision Reason
              </label>
              <textarea
                rows={3}
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="petty_offence_decision_reason"
                value={formState?.petty_offence_decision_reason ?? ""}
                onChange={handleChange}
              />
            </div>

            <div className="flex flex-col mt-4">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Petty Offence Decision Date
              </label>
              <input
                type="date"
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="petty_offence_decision_date"
                value={
                  formState?.petty_offence_decision_date
                    ? new Date(formState.petty_offence_decision_date)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={handleChange}
              />
            </div>
            <div className="flex flex-col mt-4 col-span-2">
              <FileUpload
                label="Petty Offence Decision File"
                fileTypes="*"
                required={true}
                onChange={(file) =>
                  handleFile("petty_offence_decision_file", file)
                }
              />
            </div>
          </div>
          <div className="mt-4 flex justify-between gap-2">
            <button
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
              onClick={onCancel}
              type="button"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                        font-[Poppins] cursor-pointer font-[500] w-full
                        text-base rounded-md hover:bg-white hover:text-[#E90101]
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  {LoadingIcon}
                  Loading...
                </div>
              ) : (
                "Create"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PettyOffeneRequest;
